import{a as o}from"./chunk-RAAYCPUM.js";function d(...r){return o(t,r)}var t=(r,p,e)=>({...r,[p]:e});export{d as a};
